import { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { actions as assignmentActions } from '../store/reducers/assignment.reducer'
import { DEFAULT_COLLAPSE_THRESHOLD } from '../constants/collapse-thresholds'

/**
 * Apply default collapsed state for clusters on first load only.
 * - If totalFilesCount >= threshold: collapse all clusters
 * - Otherwise: leave expanded
 * This hook runs once per mount when clusters are available and does not persist across model changes.
 */
const useDefaultClustersCollapse = (clusters, totalFilesCount, threshold = DEFAULT_COLLAPSE_THRESHOLD) => {
    const dispatch = useDispatch()
    const collapsedClusterIds = useSelector(state => state.assignment.collapsedClusterIds)
    const initialized = useSelector(state => state.assignment.clustersCollapseInitialized)
    const initializedRef = useRef(false)

    useEffect(() => {
        if (initializedRef.current || initialized) return
        if (!Array.isArray(clusters) || clusters.length === 0) return

        const total = Number(totalFilesCount) || 0
        if (collapsedClusterIds?.length > 0) {
            initializedRef.current = true
            return
        }

        if (total >= threshold) {
            // Use existing toggle-all to ensure reducer stays consistent
            dispatch(assignmentActions.switchAllClustersCollapse())
        }

        dispatch(assignmentActions.markClustersCollapseInitialized())
        initializedRef.current = true
    }, [clusters, totalFilesCount, threshold, collapsedClusterIds?.length, initialized, dispatch])
}

export default useDefaultClustersCollapse


